import { cn } from "@theprelude/core";

export const QualysIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="m21.9229 3.51153s-3.2973-3.51153-9.8546-3.51153c-6.5574 0-9.8514 3.51153-9.8514 3.51153s-.3774 2.59947-.13656 7.83317c.36333 7.9062 9.98876 12.6553 9.98956 12.6553 0 0 9.6263-4.7483 9.9896-12.6553.2408-5.2337-.1366-7.83317-.1366-7.83317zm-5.2629 12.37607c-1.1777-.1077-2.4076-.4423-2.9654-.7604 1.4367-.9179 3.3006-2.7031 3.3006-4.8734 0-2.7188-2.2098-4.93059-4.9261-4.93059-2.71631 0-4.92197 2.27392-4.92197 5.06969 0 2.3319 1.23401 4.1627 3.66807 5.44 1.5924.8367 3.9685 1.4489 6.4796 1.772-.418.6229-1.5311 1.6857-2.1825 2.0461-3.006-.4937-5.64613-1.535-7.4512-3.0965-1.93005-1.6701-2.95053-3.8487-2.95053-6.3016 0-4.06154 3.30145-7.36515 7.35933-7.36515 4.0579 0 7.3594 3.30444 7.3594 7.36605 0 2.2432-1.0486 4.3018-2.7685 5.6338z"
      fillRule="evenodd"
    />
  </svg>
);
